$(document).ready(function () {
    let inAction = false;

    const dealerHamburger = $('.dealer-hamburger');

    $('.hamburger').click(function () {
        if (inAction) return;
        inAction = true;


        if (dealerHamburger.length && dealerHamburger.hasClass('is-active'))
            dealerHamburger.click();

        $(this).toggleClass('is-active');
        $('body').toggleClass('no-scroll menued');
        $('.menu').toggleClass('active');

        setTimeout(() => inAction = false, 550);
    });

});